
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","stroke-linecap":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke-width":"2.25","d":"M12 16h.01v.01H12z"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-width":"1.5","d":"M12 12V8"}})])])
          )
        }
      }
    